<template>
  <v-badge
    :content="unReadCount"
    :value="unReadCount"
    color="success"
    overlap
  >
    <v-progress-circular v-if="loading" indeterminate></v-progress-circular>
    <v-icon v-else>mdi-forum</v-icon>

  </v-badge>
</template>
<script>
export default {
  props: ['drawer'],
  data () {
    return {
      unsubscribe: null,
      count: 0,
      loading: false
    }
  },
  computed: {
    unReadCount () {
      const diff = this.$store.state.message.public.totalCount - this.$store.state.message.public.readCount
      if (diff < 0) return 0
      return diff
    }
  },
  created () {
    this.subscribe()
  },
  destroyed () {
    if (this.unsubscribe) this.unsubscribe()
  },
  methods: {
    onError (e) {
      this.loading = false
      this.$toast.error(e.message)
    },
    subscribe () {
      this.loading = true
      this.unsubscribe = this.$firebase.firestore().collection('messages').doc('public').onSnapshot((sn) => {
        this.loading = false
        if (!sn.exists) return
        const totalCount = sn.data().countComment
        this.$store.commit('setMessageTotalCount', { collection: 'public', count: totalCount })
        if (this.drawer) this.$store.commit('setMessageReadCount', { collection: 'public', count: totalCount })
      }, this.onError)
    }
  }
}
</script>
